import objectPath from 'object-path'

const getRuleShowHideTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleShowHideDynamicKey = (status = {}) => {
  return status.dynamicKey || status.dynamicName || ''
}

const setRuleShowHideUiChanged = (designContext = {}, target) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext

  objectPath.set(isUiChanged, target, { isRender: true })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)
}

const setRuleShowHideTransition = (
  elementAction = {},
  targetKey = '',
  status = {},
) => {
  if (!status.isSelectRow) return
  if (!targetKey) return

  objectPath.set(
    elementAction,
    ['showHideTransition', targetKey],
    new Date().getTime(),
  )
}

const setRuleShowHideFormData = (
  designContext = {},
  status = {},
  targetKey = '',
  isShow,
) => {
  if (!isShow) return

  let { jsonForm = {}, setFieldFormData } = designContext
  let formData = jsonForm.formData || {}
  let sourceFormData = status.sourceFormData || status.formData || {}
  if (!objectPath.has(sourceFormData, targetKey)) return
  let currentValue = objectPath.get(formData, targetKey)
  if (
    currentValue !== undefined &&
    currentValue !== null &&
    currentValue !== ''
  ) {
    return
  }

  let value = objectPath.get(sourceFormData, targetKey)
  if (value === undefined) return

  objectPath.set(formData, targetKey, value)
  if (setFieldFormData) setFieldFormData(targetKey, value)
}

const setRuleShowHideAction = (
  designContext = {},
  action = {},
  status = {},
  isShow,
  target,
) => {
  let { elementAction = {}, setElementAction } = designContext
  let targetKey = getRuleShowHideTarget(action, target)
  if (!targetKey) return undefined

  if (status.isDynamic) {
    let dynamicKey = getRuleShowHideDynamicKey(status)
    let dynamicIndex = status.dynamicIndex || 0
    if (dynamicKey) {
      let showElement = objectPath.get(elementAction, ['isShow', dynamicKey])
      if (!Array.isArray(showElement)) {
        objectPath.set(elementAction, ['isShow', dynamicKey], [])
      }
      objectPath.set(
        elementAction,
        ['isShow', dynamicKey, dynamicIndex, targetKey].join('.'),
        isShow,
      )
    } else {
      objectPath.set(elementAction, ['isShow', targetKey], isShow)
    }
  } else {
    objectPath.set(elementAction, ['isShow', targetKey], isShow)
  }

  setRuleShowHideTransition(elementAction, targetKey, status)
  setRuleShowHideFormData(designContext, status, targetKey, isShow)
  setRuleShowHideUiChanged(designContext, targetKey)
  if (setElementAction) setElementAction(elementAction)
  return isShow
}

export const onRuleShow = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  return setRuleShowHideAction(designContext, action, status, true, target)
}

export const onRuleHide = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  return setRuleShowHideAction(designContext, action, status, false, target)
}
